var t=function(){return Math.random().toString(36).substring(2)+(new Date).getTime().toString(36)};export{t as uuid};
//# sourceMappingURL=uuid.js.map
